import { styled } from '@mui/material/styles';

export const searchContainerStyles = {
  marginTop: '10px',

  '& .MuiOutlinedInput-root': {
    pl: '0',
    borderRadius: '10px',
    fontSize: '12px',
    backgroundColor: 'rgba(241, 245, 249, 0.96)',
  },

  '& .MuiInputBase-input': {
    color: '#121d33',
    height: '30px',
    boxSizing: 'border-box',

    '&::placeholder': {
      color: '#121d33',
      opacity: '1',
    },
  },

  '& .MuiSvgIcon-root': {
    color: '#121d33',
  },
};

export const linkWithBGStyles = {
  mt: '10px',
  borderRadius: '10px',
  padding: '10px 12px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
  },

  '& a': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: '500',
  },

  '& a:hover': {
    textDecoration: 'none',
    color: '#121d33',
  },

  '& .MuiTypography-root': {
    fontSize: '12px',
    fontWeight: '500',
    color: '#fff',
    marginLeft: '10px',
  },
};

export const linkWithoutBGStyles = {
  mt: '10px',
  borderRadius: '10px',
  padding: '10px 12px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
  },

  '& a': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: '500',
  },

  '& a:hover': {
    textDecoration: 'none',
    color: '#121d33',
  },

  '& .MuiTypography-root': {
    fontSize: '12px',
    fontWeight: '500',
    marginLeft: '10px',
  },
};

export const basicLinkStyles = {
  mt: '10px',
  borderRadius: '10px',
  padding: '10px 12px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
  },

  '& a': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: '500',
  },

  '& a:hover': {
    textDecoration: 'none',
    color: '#fff',
  },

  '& .MuiTypography-root': {
    fontSize: '12px',
    fontWeight: '500',
    color: '#fff',
    marginLeft: '10px',
  },
};

export const PopperTrigger = styled('button')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  backgroundColor: 'transparent',
  color: '#fff',
  fontSize: '12px',
  fontWeight: '500',
  borderRadius: '10px',
  padding: '10px 12px',
  '&:hover': {
    textDecoration: 'none',
    color: '#fff',
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
  },
});
